import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";
import "./mobile.css";
import { GoogleOAuthProvider } from "@react-oauth/google"; // Google Login changes
import { AuthProvider } from "./context/AuthContext";
import { PointsProvider } from "./context/PointsContext";

const GOOGLE_CLIENT_ID =
  "124496933204-qmma7klpatp8q8thv6pml70slmdflslv.apps.googleusercontent.com"; // Google Login changes

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

//Google Login changes
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <PointsProvider>
          <App />
        </PointsProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
